import { NgModule } from 'ng-metadata/core';
import {RequestServicesService} from './requestsService.service';
import {PrmRequestServices} from './requestServices.directive';
import {RequestTypesModule} from './requestTypes/requestTypes.module';
import {RequestFromService} from './requestForms.service';
import {RequestService} from './request.service';
import {PrmRequest} from './request.directive';
import {PrmRequestsServicesOvl} from './requestsServicesOvl.directive';

@NgModule({
    declarations: [
        PrmRequestServices,
        PrmRequestsServicesOvl,
        PrmRequest
    ],
    providers: [
        RequestServicesService,
        RequestFromService,
        RequestService,

    ],
    imports:[
        RequestTypesModule

    ]
})
export class OpacRequestModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/opacRequest.module.ts